// root mutations
export default {
  showNavBarList(state) {
    state.showBarList = true
  },
  hideNavBarList(state) {
    state.showBarList = false
  },
  setNavStatus(state, data) {
    state.showNav = data
  },
  setNavName(state, data) {
    state.navName = data
  },
  setResourceUrl(state, data) {
    state.currentResourceUrl = data
  },
  setResourcePath(state, data) {
    state.currentResourcePath = data
  },
  setCurrentResourceId(state, id) {
    state.currentResourceId = id
  },
  updateWinHeight(state) {
    state.winHeight = window.innerHeight
  },
  updateUiMode(state) {
    // 更新当前的UI模式
    state.uiMode = window.uiMode
  },
  setMenuList(state, list) {
    state.menuList = list
  },
  setchatDialog(state, data) {
    state.chatDialog = data
  },
  setOriginMenuList(state, list) {
    state.originMenuList = list
  },
  updateMenuHistoryList(state, name) {
    // 更新菜单历史
    let flag = false
    const menuHistory = state.menuHistory
    for (let i = 0; i < menuHistory.length; i++) {
      if (menuHistory[i].name === name) {
        menuHistory[i].time = (new Date()).getTime()
        flag = true
      }
      menuHistory[i] = {
        time: menuHistory[i].time,
        name: menuHistory[i].name
      }
    }
    if (flag === false) {
      menuHistory.push({
        time: (new Date()).getTime(),
        name: name
      })
    }
    menuHistory.sort((a, b) => a.time < b.time)
    localStorage.setItem('menuHistory', JSON.stringify(menuHistory))
    state.menuHistory = menuHistory
  }
}
